import React from 'react';

interface OwnProps {
  title?: string;
  active?: boolean;
  primary?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Header navigation button (JSON, Run, Save as New).
 *
 * Styling lives in `styles.css` under `.app-navbar button.nav-btn` because
 * the button needs the gradient-navbar palette. The component itself is a
 * thin className/aria wrapper.
 */
const NavButton = ({ title, active, primary, disabled, children, onClick }: OwnProps) => {
  const className = ['nav-btn', primary && 'primary', active && 'active'].filter(Boolean).join(' ');
  return (
    <button type='button' onClick={onClick} className={className} title={title} disabled={disabled}>
      {children}
    </button>
  );
};

const MemoNavButton = React.memo(NavButton);

export { MemoNavButton as NavButton };
export default MemoNavButton;
